import { Injectable } from '@angular/core';

import { ClientePrazoPagamento } from '../cliente-prazo-pagamento';

@Injectable({
    providedIn: 'root'
})
export class ClientePrazoPagamentoSequenciaService {

    /** Ordena os prazos de pagamento pela sequência */
    sort(entities: ClientePrazoPagamento[]): ClientePrazoPagamento[] {
        if (!entities) {
            return [];
        }
        return entities.sort((prazoA, prazoB) => prazoA.sequencia - prazoB.sequencia);
    }

    /** Obtem a próxima sequência para os prazos de pagamento */
    getProximaSequencia(entities: ClientePrazoPagamento[]): number {
        if (!entities || entities.length === 0) {
            return 1;
        }

        // Ordenando pela sequência
        const entitiesSorted = this.sort(entities);
        const ultimaSequencia = entitiesSorted[entitiesSorted.length - 1].sequencia;
        return ultimaSequencia + 1;
    }

    /** Atualiza a sequência dos prazos de pagamento */
    atualizar(entities: ClientePrazoPagamento[]) {
        entities = this.sort(entities);
        let seq = 1;
        entities.forEach(entity => {
            entity.sequencia = seq;
            seq++;
        });
    }
}
